module.exports = __webpack_public_path__ + "img/incorrect_format.1766306608134.png";